import Vue from 'vue'

export default {
    get(id) {
        return Vue.axios.get(`/landing-pages/${id}`)
    },
    list(params) {
        return Vue.axios.get(`/landing-pages`, {params})
    },
    create(params) {
        return Vue.axios.post(`/landing-pages`, params)
    },
    update(id, params) {
        return Vue.axios.post(`/landing-pages/${id}`, params)
    },

}
